/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignVulnerabilityRequest,
  ResolveVulnerabilityRequest,
  VulnerabilityInstanceEntity,
} from '../models/index';
import {
    AssignVulnerabilityRequestFromJSON,
    AssignVulnerabilityRequestToJSON,
    ResolveVulnerabilityRequestFromJSON,
    ResolveVulnerabilityRequestToJSON,
    VulnerabilityInstanceEntityFromJSON,
    VulnerabilityInstanceEntityToJSON,
} from '../models/index';

export interface AssignVulnerabilityOperationRequest {
    vulnerabilityId: string;
    assignVulnerabilityRequest: AssignVulnerabilityRequest;
    sessionId?: string;
}

export interface CreateVulnerabilityRequest {
    vulnerabilityInstanceEntity: VulnerabilityInstanceEntity;
    sessionId?: string;
}

export interface DeleteVulnerabilityRequest {
    vulnerabilityId: string;
    sessionId?: string;
}

export interface GetAffectedAssets1Request {
    vulnerabilityId: string;
    sessionId?: string;
}

export interface GetVulnerabilitiesRequest {
    page?: number;
    pageSize?: number;
    severity?: string;
    resolutionStatus?: string;
    cveId?: string;
    includeGoldenRecord?: boolean;
    sessionId?: string;
}

export interface GetVulnerabilityRequest {
    vulnerabilityId: string;
    includeGoldenRecord?: boolean;
    sessionId?: string;
}

export interface GetVulnerabilityStatisticsRequest {
    sessionId?: string;
}

export interface ResolveVulnerabilityOperationRequest {
    vulnerabilityId: string;
    resolveVulnerabilityRequest: ResolveVulnerabilityRequest;
    sessionId?: string;
}

export interface UpdateVulnerabilityRequest {
    vulnerabilityId: string;
    vulnerabilityInstanceEntity: VulnerabilityInstanceEntity;
    sessionId?: string;
}

/**
 * VulnerabilitiesApi - interface
 * 
 * @export
 * @interface VulnerabilitiesApiInterface
 */
export interface VulnerabilitiesApiInterface {
    /**
     * Assign a vulnerability to a user, team, or group
     * @summary Assign vulnerability
     * @param {string} vulnerabilityId Vulnerability instance ID
     * @param {AssignVulnerabilityRequest} assignVulnerabilityRequest 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    assignVulnerabilityRaw(requestParameters: AssignVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Assign a vulnerability to a user, team, or group
     * Assign vulnerability
     */
    assignVulnerability(requestParameters: AssignVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Create a new vulnerability instance (manual creation - primary source is integrations)
     * @summary Create vulnerability
     * @param {VulnerabilityInstanceEntity} vulnerabilityInstanceEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    createVulnerabilityRaw(requestParameters: CreateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a new vulnerability instance (manual creation - primary source is integrations)
     * Create vulnerability
     */
    createVulnerability(requestParameters: CreateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Soft delete a vulnerability instance (retains for audit/compliance)
     * @summary Delete vulnerability
     * @param {string} vulnerabilityId Vulnerability instance ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    deleteVulnerabilityRaw(requestParameters: DeleteVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Soft delete a vulnerability instance (retains for audit/compliance)
     * Delete vulnerability
     */
    deleteVulnerability(requestParameters: DeleteVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all assets affected by this vulnerability
     * @summary Get affected assets
     * @param {string} vulnerabilityId Vulnerability instance ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    getAffectedAssets1Raw(requestParameters: GetAffectedAssets1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all assets affected by this vulnerability
     * Get affected assets
     */
    getAffectedAssets1(requestParameters: GetAffectedAssets1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get paginated list of active vulnerability instances
     * @summary List vulnerabilities
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [severity] Severity filter
     * @param {string} [resolutionStatus] Resolution status filter
     * @param {string} [cveId] CVE ID filter
     * @param {boolean} [includeGoldenRecord] Include MDM golden record payload per row (heavier)
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    getVulnerabilitiesRaw(requestParameters: GetVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get paginated list of active vulnerability instances
     * List vulnerabilities
     */
    getVulnerabilities(requestParameters: GetVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed information about a vulnerability instance
     * @summary Get vulnerability by ID
     * @param {string} vulnerabilityId Vulnerability instance ID
     * @param {boolean} [includeGoldenRecord] Include MDM golden record payload
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    getVulnerabilityRaw(requestParameters: GetVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about a vulnerability instance
     * Get vulnerability by ID
     */
    getVulnerability(requestParameters: GetVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get statistics about vulnerabilities (total, by severity, by status)
     * @summary Get vulnerability statistics
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    getVulnerabilityStatisticsRaw(requestParameters: GetVulnerabilityStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get statistics about vulnerabilities (total, by severity, by status)
     * Get vulnerability statistics
     */
    getVulnerabilityStatistics(requestParameters: GetVulnerabilityStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Mark a vulnerability as resolved
     * @summary Resolve vulnerability
     * @param {string} vulnerabilityId Vulnerability instance ID
     * @param {ResolveVulnerabilityRequest} resolveVulnerabilityRequest 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    resolveVulnerabilityRaw(requestParameters: ResolveVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Mark a vulnerability as resolved
     * Resolve vulnerability
     */
    resolveVulnerability(requestParameters: ResolveVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update an existing vulnerability instance
     * @summary Update vulnerability
     * @param {string} vulnerabilityId Vulnerability instance ID
     * @param {VulnerabilityInstanceEntity} vulnerabilityInstanceEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VulnerabilitiesApiInterface
     */
    updateVulnerabilityRaw(requestParameters: UpdateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update an existing vulnerability instance
     * Update vulnerability
     */
    updateVulnerability(requestParameters: UpdateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class VulnerabilitiesApi extends runtime.BaseAPI implements VulnerabilitiesApiInterface {

    /**
     * Assign a vulnerability to a user, team, or group
     * Assign vulnerability
     */
    async assignVulnerabilityRaw(requestParameters: AssignVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['vulnerabilityId'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityId',
                'Required parameter "vulnerabilityId" was null or undefined when calling assignVulnerability().'
            );
        }

        if (requestParameters['assignVulnerabilityRequest'] == null) {
            throw new runtime.RequiredError(
                'assignVulnerabilityRequest',
                'Required parameter "assignVulnerabilityRequest" was null or undefined when calling assignVulnerability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/vulnerabilities/{vulnerabilityId}/assign`;
        urlPath = urlPath.replace(`{${"vulnerabilityId"}}`, encodeURIComponent(String(requestParameters['vulnerabilityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignVulnerabilityRequestToJSON(requestParameters['assignVulnerabilityRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Assign a vulnerability to a user, team, or group
     * Assign vulnerability
     */
    async assignVulnerability(requestParameters: AssignVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.assignVulnerabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new vulnerability instance (manual creation - primary source is integrations)
     * Create vulnerability
     */
    async createVulnerabilityRaw(requestParameters: CreateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['vulnerabilityInstanceEntity'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityInstanceEntity',
                'Required parameter "vulnerabilityInstanceEntity" was null or undefined when calling createVulnerability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/vulnerabilities`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VulnerabilityInstanceEntityToJSON(requestParameters['vulnerabilityInstanceEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a new vulnerability instance (manual creation - primary source is integrations)
     * Create vulnerability
     */
    async createVulnerability(requestParameters: CreateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createVulnerabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete a vulnerability instance (retains for audit/compliance)
     * Delete vulnerability
     */
    async deleteVulnerabilityRaw(requestParameters: DeleteVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['vulnerabilityId'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityId',
                'Required parameter "vulnerabilityId" was null or undefined when calling deleteVulnerability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/vulnerabilities/{vulnerabilityId}`;
        urlPath = urlPath.replace(`{${"vulnerabilityId"}}`, encodeURIComponent(String(requestParameters['vulnerabilityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Soft delete a vulnerability instance (retains for audit/compliance)
     * Delete vulnerability
     */
    async deleteVulnerability(requestParameters: DeleteVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteVulnerabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all assets affected by this vulnerability
     * Get affected assets
     */
    async getAffectedAssets1Raw(requestParameters: GetAffectedAssets1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['vulnerabilityId'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityId',
                'Required parameter "vulnerabilityId" was null or undefined when calling getAffectedAssets1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/vulnerabilities/{vulnerabilityId}/affected-assets`;
        urlPath = urlPath.replace(`{${"vulnerabilityId"}}`, encodeURIComponent(String(requestParameters['vulnerabilityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all assets affected by this vulnerability
     * Get affected assets
     */
    async getAffectedAssets1(requestParameters: GetAffectedAssets1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAffectedAssets1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paginated list of active vulnerability instances
     * List vulnerabilities
     */
    async getVulnerabilitiesRaw(requestParameters: GetVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['resolutionStatus'] != null) {
            queryParameters['resolutionStatus'] = requestParameters['resolutionStatus'];
        }

        if (requestParameters['cveId'] != null) {
            queryParameters['cveId'] = requestParameters['cveId'];
        }

        if (requestParameters['includeGoldenRecord'] != null) {
            queryParameters['includeGoldenRecord'] = requestParameters['includeGoldenRecord'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/vulnerabilities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get paginated list of active vulnerability instances
     * List vulnerabilities
     */
    async getVulnerabilities(requestParameters: GetVulnerabilitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getVulnerabilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a vulnerability instance
     * Get vulnerability by ID
     */
    async getVulnerabilityRaw(requestParameters: GetVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['vulnerabilityId'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityId',
                'Required parameter "vulnerabilityId" was null or undefined when calling getVulnerability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeGoldenRecord'] != null) {
            queryParameters['includeGoldenRecord'] = requestParameters['includeGoldenRecord'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/vulnerabilities/{vulnerabilityId}`;
        urlPath = urlPath.replace(`{${"vulnerabilityId"}}`, encodeURIComponent(String(requestParameters['vulnerabilityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about a vulnerability instance
     * Get vulnerability by ID
     */
    async getVulnerability(requestParameters: GetVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getVulnerabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about vulnerabilities (total, by severity, by status)
     * Get vulnerability statistics
     */
    async getVulnerabilityStatisticsRaw(requestParameters: GetVulnerabilityStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/vulnerabilities/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get statistics about vulnerabilities (total, by severity, by status)
     * Get vulnerability statistics
     */
    async getVulnerabilityStatistics(requestParameters: GetVulnerabilityStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getVulnerabilityStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a vulnerability as resolved
     * Resolve vulnerability
     */
    async resolveVulnerabilityRaw(requestParameters: ResolveVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['vulnerabilityId'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityId',
                'Required parameter "vulnerabilityId" was null or undefined when calling resolveVulnerability().'
            );
        }

        if (requestParameters['resolveVulnerabilityRequest'] == null) {
            throw new runtime.RequiredError(
                'resolveVulnerabilityRequest',
                'Required parameter "resolveVulnerabilityRequest" was null or undefined when calling resolveVulnerability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/vulnerabilities/{vulnerabilityId}/resolve`;
        urlPath = urlPath.replace(`{${"vulnerabilityId"}}`, encodeURIComponent(String(requestParameters['vulnerabilityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveVulnerabilityRequestToJSON(requestParameters['resolveVulnerabilityRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Mark a vulnerability as resolved
     * Resolve vulnerability
     */
    async resolveVulnerability(requestParameters: ResolveVulnerabilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resolveVulnerabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing vulnerability instance
     * Update vulnerability
     */
    async updateVulnerabilityRaw(requestParameters: UpdateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['vulnerabilityId'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityId',
                'Required parameter "vulnerabilityId" was null or undefined when calling updateVulnerability().'
            );
        }

        if (requestParameters['vulnerabilityInstanceEntity'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityInstanceEntity',
                'Required parameter "vulnerabilityInstanceEntity" was null or undefined when calling updateVulnerability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/vulnerabilities/{vulnerabilityId}`;
        urlPath = urlPath.replace(`{${"vulnerabilityId"}}`, encodeURIComponent(String(requestParameters['vulnerabilityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VulnerabilityInstanceEntityToJSON(requestParameters['vulnerabilityInstanceEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update an existing vulnerability instance
     * Update vulnerability
     */
    async updateVulnerability(requestParameters: UpdateVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateVulnerabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
